import { Injectable } from '@angular/core';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { EmptyData } from '@admin/core/models/empty-data';
import { PagingWrapper } from '@admin/core/models/paging-wrapper';
import { UrlConfigContainer } from '@admin/core/url-config';
import { UrlConfigService } from '@hrra/core';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { Observable } from 'rxjs';
import { CustomerBrandingAccessTokenFilterModel } from '../models/customer-branding-access-token-filter-model';
import { CustomerBrandingAccessTokenModel } from '../models/customer-branding-access-token-model';
import { CustomerBrandingRequestActionData } from '../models/customer-branding-request-action-data';
import { CustomerBrandingRequestAction } from '../models/customer-branding-request-action.enum';

@Injectable({
  providedIn: 'root',
})
export class BrandingProductServiceService {
  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}

  public listBrandingRequests(
    filter: PagingFilter<CustomerBrandingAccessTokenFilterModel>
  ): Observable<PagingWrapper<CustomerBrandingAccessTokenModel>> {
    const url = this.urlService.urlConfig.api.data.productPurchases.branding.request.list;
    return this.ajax.postDataPaging(
      url,
      filter.toObject(),
      CustomerBrandingAccessTokenModel
    );
  }

  public approveBrandingRequest(request: CustomerBrandingAccessTokenModel) {
    const data = <CustomerBrandingRequestActionData>{
      action: CustomerBrandingRequestAction.Approve,
      customerBrandingAccessTokenId: request.customerBrandingAccessTokenId,
    };

    const url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.branding.request.process,
      { id: request.customerBrandingAccessTokenId }
    );
    return this.ajax.postData(url, data, EmptyData);
  }

  public rejectBrandingRequest(request: CustomerBrandingAccessTokenModel) {
    const data = <CustomerBrandingRequestActionData>{
      action: CustomerBrandingRequestAction.Reject,
      customerBrandingAccessTokenId: request.customerBrandingAccessTokenId,
    };
    const url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.branding.request.process,
      { id: request.customerBrandingAccessTokenId }
    );

    return this.ajax.postData(url, data, EmptyData);
  }

  public revokeBrandingRequest(
    brandingAccessTokenId: number,
    affectBilling: boolean
  ) {
    const data = <CustomerBrandingRequestActionData>{
      action: CustomerBrandingRequestAction.Revoke,
      customerBrandingAccessTokenId: brandingAccessTokenId,
      affectBilling: affectBilling,
    };

    const url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.branding.request.process,
      { id: brandingAccessTokenId }
    );

    return this.ajax.postData(url, data, EmptyData);
  }

  public approveBrandingRequestWithModification(
    request: CustomerBrandingAccessTokenModel,
    newStoreItemId: number
  ) {
    const data = <CustomerBrandingRequestActionData>{
      action: CustomerBrandingRequestAction.ApproveWithModification,
      customerBrandingAccessTokenId: request.customerBrandingAccessTokenId,
      newStoreItemId: newStoreItemId,
    };
    const url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.branding.request.process,
      { id: request.customerBrandingAccessTokenId }
    );

    return this.ajax.postData(url, data, EmptyData);
  }
}
